import type { FaireProductEntity } from "../../entity_types/product";

export const p_86zhqscuzx: FaireProductEntity = {
  token: "p_86zhqscuzx",
  type: "product",
  name: "ViA HEAT Insulating Crystal Tea Bottle without GemPod",
  brandToken: "b_6jphlq246l",
  brandName: "VitaJuwel USA",
  imageUrl:
    "https://cdn.faire.com/fastly/7bfe720b8611a5d61b38eac343e3890d1a36e141292b5835faf862692c14af7e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/452821bd7006e0e352ebc88caf2f5981995b156fd257324c8933b45d4d1ccf40.jpeg",
    "https://cdn.faire.com/fastly/19cd69951f9050cd5d3672ae840f12bb22136e5f1296043e6743045275e3cbcb.jpeg",
    "https://cdn.faire.com/fastly/77be682ddeb4137a7f224f3e7da9700aeb8767a0187e6dfd491b7b50add07410.jpeg",
  ],
  priceDollars: 30.49,
  description:
    "This product comes without a GemPod and is intended to be either a replacement or for those who already own one or more Gempods from other products and would like to add variety to their hydration routines.\n\nCRYSTAL VIBES. Naturopathic doctors have been using the vibrant energy of precious stones to prepare potent crystal elixirs for their therapies for many years. With the help of gemologists we’ve reinterpreted this tradition and created a select number of unique crystal blends aimed at specific crystal attributes. Get one of our VitaJuwel ViA GemPods or use the glass insert of the GemPod in your regular ViA Bottle.\n\nVERSATILE. Choose one of 13 traditional gemstone blends. Enjoy your loose leaf tea with the (optional) large capacity, stainless steel tea strainer. \n\nSUSTAINABLE. Stop using paper cups from your coffee shop and let them fill your ViA HEAT instead.",
  tags: [],
  msrpDollars: 60.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:47.344Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
